<template>
  <div id="contenedor-eliminar-pago">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar {{ this.tipo }} </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el {{ this.tipo }}? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="eliminar"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixPagos from '../mixPagos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarPago',
  mixins: [mixPagos],
  props: {
    pagoEliminar: {
      type: Object,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    async eliminar() {
      if (this.tipo === 'pago') {
        await this.mixEliminarPago();
      }
      if (this.tipo === 'detalle de pago') {
        await this.mixEliminarPagoDetalle();
      }
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
